module.exports = __webpack_public_path__ + "static/media/iconic-offices.581eed87.png";